// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"968f8cf539adde6c8e67","293":"7e4e4be6d0fcd202461e","461":"9661bcdbae999a02e016","518":"2bc1dce94e2a3a1b79ce","779":"8a4aabf72ed1e0c9817e"}[chunkId] + ".js";
};